import { Button, GestureResponderEvent, StyleSheet, Text, View } from 'react-native';

import React, { useRef } from 'react';
import { store } from '../store/store';
import menuSlice, { selectMenu, setMenu } from '../store/slices/menuSlice';
import { MenuOptions } from './menu/SideBar';
import { captureScreen } from "react-native-view-shot";
import { selectAdvance, setAdvance } from '../store/slices/AdvanceSlice';
import { useAppSelector } from '../store/hooks';
import Icon from 'react-native-vector-icons/FontAwesome';
import useFontSize from '../shell/hooks/useFontSize';
import { doRedo, doUndo } from './doUndoRedo';

interface AndroidLayoutProps {

}

export const AndroidLayout: React.FC<AndroidLayoutProps> = ({ }) => {
    const imageRef = useRef<string | undefined>();
    const menuSlice = useAppSelector(selectMenu);
    const advanceSlice = useAppSelector(selectAdvance);

    const styles = StyleSheet.create({
        container: {
            position: "absolute",
            bottom: 0,
            display: "flex",
            flexDirection: "row",
            width: "100%",
            alignContent: "center",
            alignSelf: "center",
            justifyContent: "space-evenly"

        },
        text: {
            color: "white",
            borderColor: "black",


        },
        arrowBack: {
            color: "white"

        }

    });

    const onSavePressed = async () => {
        const image = await captureScreen({
            format: "jpg",
            result: "base64",
            quality: 0.6
        });
        store.dispatch(setMenu({ display: true, menuState: MenuOptions.SAVE, mobileImage: "data:image/png;base64," + image }));
    };
    const onSkipPressed = async (event: GestureResponderEvent) => {
        event.preventDefault();
        event.stopPropagation();

        store.dispatch(setAdvance({ canAdvance: true, skipping: !advanceSlice.skipping, promise: undefined }));
    };
    const onForwardPressed = async () => {
        doRedo();
    };
    const onBackPressed = async () => {
        doUndo();
    };

    return (
        <View style={styles.container}>
            {/* <Button title={"Save"} onPress={() => { onSavePressed(); }}></Button> */}
            <Text style={styles.text} onPress={() => { onSavePressed(); }} >Save</Text>
            <Icon name={'angle-double-left'} onPress={() => onForwardPressed()} style={styles.arrowBack} size={useFontSize(4)} />
            <Icon name={'angle-double-right'} onPress={() => onBackPressed()} style={styles.arrowBack} size={useFontSize(4)} />
            <Text style={styles.text} onPress={(event) => { onSkipPressed(event); }} >skip</Text>

        </View>
    );
};